module.exports = __webpack_public_path__ + "static/img/platform-api.3d5bdf38.png";